var Backbone = require('backbone');
var _ = require('underscore');

require('./BlockGallery.less');

module.exports = Backbone.View.extend({
    events: {
        'click .BlockGallery-enlarge': 'showGallery'
    },

    initialize: function (options) {
        options = options || {};

        this.galleryView = options.galleryView;

        this.$slider = this.$('.BlockGallery-slider');
        this.$prev = this.$('.BlockGallery-prev');
        this.$next = this.$('.BlockGallery-next');
        this.$copyright = this.$('.BlockGallery-copyright');
        this.$slideNumber = this.$('.BlockGallery-slideNumber');
        this.$items = this.$('.BlockGallery-item');

        this.slideIndex = 0;
        this.pageIndex = 0;

        this.checkAspectRatios();

        if (this.$slider.length) {
            this.initSlider();
        }
    },

    initSlider: function () {
        var self = this;

        this.$slider.owlCarousel({
            items: 1,
            mouseDrag: true,
            lazyLoad: false,
            loop: true,
            nav: false,
            slideBy: 'page',
            autoplay: false
        });

        this.$prev.on('click', function () {
            self.$slider.trigger('prev.owl.carousel');
        });

        this.$next.on('click', function () {
            self.$slider.trigger('next.owl.carousel');
        });

        this.$slider.on('changed.owl.carousel', function (evt) {
            self.slideIndex = evt.item.index; //Номер слайда учитывая клонов
            self.pageIndex = evt.page.index; //Номер слайда не учитывая склонированные элементы

            var elementData = $(evt.target).find(".owl-item")
                .eq(self.slideIndex)
                .find('.BlockGallery-item')
                .data();

            self.$copyright.html(elementData.copyright || '');
            self.$slideNumber.html(self.pageIndex + 1);
        });
    },

    showGallery: function () {
        var $sliderItems = this.$el.find('.owl-item:not(.cloned) .BlockGallery-item');

        this.galleryView.show(this);
    },

    showSlide: function (index) {
        this.$slider.trigger('to.owl.carousel', [index, 300, true]);
    },

    checkAspectRatios: function () {
        var containerAspectRatio = this.$el.width() / this.$el.height();

        this.$items.each(function (index, el) {
            var $el = $(el);
            var itemAspectRatio = $el.data('width') / $el.data('height');

            if (itemAspectRatio > containerAspectRatio) {
                $el.css('object-fit', 'cover');
            }
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/BlockGallery/BlockGallery.js
// module id = 20
// module chunks = 0